/**
 * Visor Ebook mejorado
 *
 * @version 2
 * @author Diego Alberto Yance Arqque - diegoyance98@gmail.com
 */

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

import "@/assets/css/normalize.min.css";
import "@/assets/css/app.css";
import "@/assets/css/fonts.css";
import "@/assets/css/icons.css";
import "@/assets/css/tools.css";
import "@/assets/fontawesome/css/all.css";

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
